const initialState = {
  loading: true,
  error: false,
  subscriptionIds: {},
  productSubscriptions: {}
};

// Remove a assinatura e desfaz o `resumedToId` que apontava para ela — é o
// que faz o painel voltar a mostrar a original.
const withoutSubscription = (subscriptions = {}, id) => Object.fromEntries(
  Object.entries(subscriptions)
    .filter(([key]) => String(key) !== String(id))
    .map(([key, subscription]) => [
      key,
      subscription?.resumedToId === id ? { ...subscription, resumedToId: null } : subscription,
    ]),
);

export default function subscriptionsListReducer(state = initialState, action) {
  switch (action.type) {
    case "SUBSCRIPTIONS_FETCH_REQUESTED":
    case "PRODUCT_SUBSCRIPTIONS_FETCH_REQUESTED":
      return {
        ...state,
        loading: true,
        error: false
      };
    case "SUBSCRIPTIONS_FETCHED":
      return {
        ...state,
        loading: false,
        error: false,
        subscriptions: action.entities.subscriptions || {},
      };
    case "PRODUCT_SUBSCRIPTIONS_FETCHED":
      return {
        ...state,
        loading: false,
        error: false,
        productSubscriptions: {
          ...state.productSubscriptions,
          [action.productId]: {
            ids: action.result || [],
            pagination: action.pagination || {},
          }
        }
      };
    case "SUBSCRIPTIONS_FETCH_FAILED":
    case "PRODUCT_SUBSCRIPTIONS_FETCH_FAILED":
      return {
        ...state,
        loading: false,
        error: true
      };
    case "SUBSCRIPTION_UPDATED":
      return {
        ...state,
        subscriptions: {
          ...state.subscriptions,
          ...action.entities.subscriptions,
        }
      };
    case "SUBSCRIPTION_REMOVED": {
      const rest = withoutSubscription(state.subscriptions, action.id);
      return {
        ...state,
        subscriptions: rest,
      };
    }
    default:
      return state;
  }
}
